export enum SpeakerType {
  /** 用户自定义上传音色 */
  UserUpload = 'user_upload',
  /** 快速克隆系统根据speaker分割音频片段生成声音样本 */
  SystemGenerate = 'system_generate',
  /** ai模型生成 */
  AiModel = 'ai_model',
}
